import { takeLatest, call, put, all } from "redux-saga/effects";
import { store } from "../redux/store";

import {
  fetchHistories,
  fetchDCAs,
  fetchOrders,
  fetchPortfolioGroups,
  fetchNavPortfolios,
  fetchLots,
  fetchBooks,
  fetchDividends,
  fetchPreviousReturnByAccount,
  fetchPreviousReturnGraphByAccount,
  fetchAumGraphByAccount,
  fetchMonthlyReturnByAccount,
  fetchMaxDrawdownByAccount,
  fetchDrawdownByAccount,
  fetchLastDateOfAccountNumber,
  fetchVolatilityByAccount,
  fetchProfitByAccount,
  fetchActivedFunds,
  fetchAllFunds,
  fetchAllFundCodes,
  deleteOrderRequestFund,
  deleteDCAOrderRequestFund,
} from "../_services/investment.services";

import { investmentConstants } from "../_constants";

import {
  fetchHistoriesSuccess,
  fetchHistoriesFailure,
  fetchDCAsStart,
  fetchDCAsSuccess,
  fetchDCAsFailure,
  fetchPortfoliosSuccess,
  fetchPortfoliosFailure,
  fetchNavPortfoliosSuccess,
  fetchNavPortfoliosFailure,
  fetchDividendsSuccess,
  fetchDividendsFailure,
  fetchOrdersStart,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  fetchLotsSuccess,
  fetchLotsFailure,
  fetchNavsLotsSuccess,
  fetchNavsLotsFailure,
  fetchBooksSuccess,
  fetchBooksFailure,
  fetchPreviousReturnByAccountSuccess,
  fetchPreviousReturnByAccountFailure,
  fetchPreviousReturnGraphByAccountSuccess,
  fetchPreviousReturnGraphByAccountFailure,
  fetchHistoryGraphByAccountSuccess,
  fetchHistoryGraphByAccountFailure,
  fetchMonthlyReturnByAccountSuccess,
  fetchMonthlyReturnByAccountFailure,
  fetchMaxDrawdownByAccountSuccess,
  fetchMaxDrawdownByAccountFailure,
  fetchDrawdownByAccountSuccess,
  fetchDrawdownByAccountFailure,
  fetchLastDateOfAccountNumberSuccess,
  fetchLastDateOfAccountNumberFailure,
  fetchVolatilityByAccountSuccess,
  fetchVolatilityByAccountFailure,
  fetchProfitByAccountSuccess,
  fetchProfitByAccountFailure,
  fetchActivedFundsSuccess,
  fetchActivedFundsFailure,
  fetchAllFundsSuccess,
  fetchAllFundsFailure,
  fetchAllFundCodesSuccess,
  fetchAllFundCodesFailure,
  deleteOrderRequestSuccess,
  deleteOrderRequestFailure,
  deleteDCAOrderRequestSuccess,
  deleteDCAOrderRequestFailure,
} from "../_actions/investment.actions";

import { signOut } from "../_actions/authentication.actions";

export function* fetchActivedFundsAsync({ payload }) {
  try {
    const result = yield call(fetchActivedFunds, payload);
    yield put(fetchActivedFundsSuccess(result.data));
  } catch (error) {
    yield put(fetchActivedFundsFailure(error.message));
  }
}

export function* fetchAllFundsAsync({ payload }) {
  try {
    const result = yield call(fetchAllFunds, payload);
    yield put(fetchAllFundsSuccess(result.data));
  } catch (error) {
    yield put(fetchAllFundsFailure(error.message));
  }
}

export function* fetchAllFundCodesAsync() {
  try {
    const result = yield call(fetchAllFundCodes);
    yield put(fetchAllFundCodesSuccess(result.data));
  } catch (error) {
    yield put(fetchAllFundCodesFailure(error.message));
  }
}

export function* fetchHistoriesAsync({ payload }) {
  try {
    const result = yield call(fetchHistories, payload);
    yield put(fetchHistoriesSuccess(result.data));
  } catch (error) {
    yield put(fetchHistoriesFailure(error.message));
  }
}

export function* deleteDCAOrderRequestStartAsync({ payload }) {
  try {
    const result = yield call(deleteDCAOrderRequestFund, payload);
    yield put(deleteDCAOrderRequestSuccess(result.data));
    const state = store.getState();
    const accounts = state.investment.userAccounts;
    const dcaOrderQueries = state.investment.dca.queries;
    const queries = {
      accountNumbers: accounts.map((x) => x.accountNumber),
      sortBy: dcaOrderQueries.sortBy,
      sortType: dcaOrderQueries.sortType,
      isActive:
        dcaOrderQueries.status?.value !== ""
          ? dcaOrderQueries.status.value
          : null,
      type: dcaOrderQueries.type?.value,
      funds: dcaOrderQueries.funds?.map((x) => x.fundCode),
    };
    yield put(fetchDCAsStart(queries));
  } catch (error) {
    yield put(deleteDCAOrderRequestFailure(error));
  }
}

export function* fetchDCAsAsync({ payload }) {
  try {
    let result = yield call(fetchDCAs, payload);
    yield put(fetchDCAsSuccess(result.data));
  } catch (error) {
    yield put(fetchDCAsFailure(error.message));
  }
}

export function* fetchPortfoliosAsync({ payload }) {
  try {
    const result = yield call(fetchPortfolioGroups, payload);
    yield put(fetchPortfoliosSuccess(result.data));
  } catch (error) {
    yield put(fetchPortfoliosFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //   yield put(signOut());
    // }
  }
}
export function* fetchNavPortfoliosAsync({ payload }) {
  try {
    const result = yield call(fetchNavPortfolios, payload);
    yield put(fetchNavPortfoliosSuccess(result.data));
  } catch (error) {
    yield put(fetchNavPortfoliosFailure(error.message));
  }
}
export function* fetchPreviousReturnByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchPreviousReturnByAccount, payload);
    yield put(fetchPreviousReturnByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchPreviousReturnByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchHistoryGraphByAccountAsync({ payload }) {
  try {
    const { account, date, graphMode, dateType } = payload;
    let result;
    const queries = { ...date, dateType };

    switch (graphMode) {
      case "PREVIOUSE_RETURN":
        result = yield call(
          fetchPreviousReturnGraphByAccount,
          account,
          queries
        );
        break;
      case "AUM":
        result = yield call(fetchAumGraphByAccount, account, queries);
        break;
      case "ALL":
        let previousReturn = yield call(
          fetchPreviousReturnGraphByAccount,
          account,
          queries
        );
        let aum = yield call(fetchAumGraphByAccount, account, queries);
        result = previousReturn;
        if (result.data && result.data.length > 0) {
          result.data = result.data.map((obj) => {
            let secondValue;
            aum.data.forEach((obj2) => {
              if (obj.date === obj2.date) {
                secondValue = obj2.value;
              }
            });
            return {
              date: obj.date,
              leftGraphPoint: obj.value,
              rightGraphPoint: secondValue,
            };
          });
        }
        break;
      default:
        break;
    }
    yield put(fetchHistoryGraphByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchHistoryGraphByAccountFailure(error.message));
  }
}
export function* fetchPreviousReturnGraphByAccountAsync({ payload }) {
  try {
    const result = yield call(
      fetchPreviousReturnGraphByAccount,
      payload.account,
      payload.data
    );
    yield put(fetchPreviousReturnGraphByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchPreviousReturnGraphByAccountFailure(error.message));
  }
}
export function* fetchProfitByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchProfitByAccount, payload);
    yield put(fetchProfitByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchProfitByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchMonthlyReturnByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchMonthlyReturnByAccount, payload);
    yield put(fetchMonthlyReturnByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchMonthlyReturnByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchMaxDrawdownByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchMaxDrawdownByAccount, payload);
    yield put(fetchMaxDrawdownByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchMaxDrawdownByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchDrawdownByAccountAsync({ payload }) {
  try {
    const result = yield call(
      fetchDrawdownByAccount,
      payload.account,
      payload.data
    );
    yield put(fetchDrawdownByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchDrawdownByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* setDefaultPortStatAsync() {
  try {
    const state = store.getState();
    const accountNumber = state.investment.userAccounts[0]?.accountNumber;
    const result = yield call(fetchLastDateOfAccountNumber, accountNumber);
    yield put(fetchLastDateOfAccountNumberSuccess(result.data));
  } catch (error) {
    yield put(fetchLastDateOfAccountNumberFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}

export function* fetchVolatilityByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchVolatilityByAccount, payload);
    yield put(fetchVolatilityByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchVolatilityByAccountFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchLotsAsync({ payload }) {
  try {
    const result = yield call(fetchLots, payload);
    yield put(fetchLotsSuccess(result.data));
  } catch (error) {
    yield put(fetchLotsFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchNavsLotsAsync({ payload }) {
  try {
    const result = yield call(fetchNavPortfolios, payload);
    yield put(fetchNavsLotsSuccess(result.data));
  } catch (error) {
    yield put(fetchNavsLotsFailure(error.message));
  }
}
export function* fetchBooksAsync() {
  try {
    const { investment } = store.getState();
    const payload = {
      accountNumber: investment.userAccounts[0]?.accountNumber,
      fundIds: investment.book.queries.funds
        .filter((fund) => fund.fundId)
        .map((fund) => fund.fundId),
      fundCodes: investment.book.queries.funds
        .filter((fund) => fund.fundCode)
        .map((fund) => fund.fundCode),
      startDate: investment.book.queries.date.startDate,
      endDate: investment.book.queries.date.endDate,
    };
    const result = yield call(fetchBooks, payload);
    yield put(fetchBooksSuccess(result.data));
  } catch (error) {
    yield put(fetchBooksFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchDividendsAsync({ payload }) {
  try {
    const result = yield call(fetchDividends, payload);
    yield put(fetchDividendsSuccess(result.data));
  } catch (error) {
    yield put(fetchDividendsFailure(error.message));

    // Sign Out if Status 401
    // if (error.response?.status === 401) {
    //    yield put(signOut());
    //  }
  }
}
export function* fetchOrdersAsync({ payload }) {
  try {
    const result = yield call(fetchOrders, payload);
    yield put(fetchOrdersSuccess(result.data));
  } catch (error) {
    yield put(fetchOrdersFailure(error.message));
  }
}

export function* deleteOrderRequestStartAsync({ payload }) {
  try {
    const result = yield call(deleteOrderRequestFund, payload);
    yield put(deleteOrderRequestSuccess(result.data));
    const state = store.getState();
    const accounts = state.investment.userAccounts;
    const orderQueries = state.investment.order.queries;
    const queries = {
      accountNumbers: accounts.map((x) => x.accountNumber),
      sortBy: orderQueries.sortBy,
      sortType: orderQueries.sortType,
      status: orderQueries.status?.value,
      tradeType: orderQueries.tradeType?.value,
      remark: orderQueries.remark?.value,
    };
    yield put(fetchOrdersStart(queries));
  } catch (error) {
    yield put(deleteOrderRequestFailure(error));
  }
}

export function* fetchActivedFundsStart() {
  yield takeLatest(
    investmentConstants.FETCH_ACTIVED_FUNDS_START,
    fetchActivedFundsAsync
  );
}
export function* fetchAllFundsStart() {
  yield takeLatest(
    investmentConstants.FETCH_ALL_FUNDS_START,
    fetchAllFundsAsync
  );
}
export function* fetchAllFundCodesStart() {
  yield takeLatest(
    investmentConstants.FETCH_ALL_FUND_CODES_START,
    fetchAllFundCodesAsync
  );
}
export function* fetchHistoriesStart() {
  yield takeLatest(
    investmentConstants.FETCH_HISTORIES_START,
    fetchHistoriesAsync
  );
}
export function* fetchDCAsSagaStart() {
  yield takeLatest(investmentConstants.FETCH_DCAS_START, fetchDCAsAsync);
}
export function* fetchPortfoliosStart() {
  yield takeLatest(
    investmentConstants.FETCH_PORTFOLIOS_START,
    fetchPortfoliosAsync
  );
}
export function* fetchNavPortfoliosStart() {
  yield takeLatest(
    investmentConstants.FETCH_NAV_PORTFOLIO_START,
    fetchNavPortfoliosAsync
  );
}
export function* fetchPreviousReturnByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_START,
    fetchPreviousReturnByAccountAsync
  );
}
export function* fetchHistoryGraphByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_START,
    fetchHistoryGraphByAccountAsync
  );
}
export function* fetchPreviousReturnGraphByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_START,
    fetchPreviousReturnGraphByAccountAsync
  );
}
export function* fetchProfitByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_PROFIT_BY_ACCOUNT_START,
    fetchProfitByAccountAsync
  );
}
export function* fetchMonthlyReturnByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_START,
    fetchMonthlyReturnByAccountAsync
  );
}
export function* fetchVolatilityByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_START,
    fetchVolatilityByAccountAsync
  );
}
export function* fetchMaxDrawdownByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_START,
    fetchMaxDrawdownByAccountAsync
  );
}
export function* fetchDrawdownByAccountStart() {
  yield takeLatest(
    investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_START,
    fetchDrawdownByAccountAsync
  );
}
export function* setDefaultPortStatStart() {
  yield takeLatest(
    investmentConstants.SET_DEFAULT_PORT_STAT,
    setDefaultPortStatAsync
  );
}
export function* fetchLotsStart() {
  yield takeLatest(investmentConstants.FETCH_LOTS_START, fetchLotsAsync);
}
export function* fetchNavsLotsStart() {
  yield takeLatest(
    investmentConstants.FETCH_NAVS_LOTS_START,
    fetchNavsLotsAsync
  );
}
export function* fetchBooksStart() {
  yield takeLatest(investmentConstants.FETCH_BOOKS_START, fetchBooksAsync);
}
export function* fetchDividendsStart() {
  yield takeLatest(
    investmentConstants.FETCH_DIVIDENDS_START,
    fetchDividendsAsync
  );
}
export function* fetchOrdersSagaStart() {
  yield takeLatest(investmentConstants.FETCH_ORDERS_START, fetchOrdersAsync);
}
export function* deleteOrderRequestStart() {
  yield takeLatest(
    investmentConstants.DELETE_ORDER_REQUEST_START,
    deleteOrderRequestStartAsync
  );
}
export function* deleteDCAOrderRequestStart() {
  yield takeLatest(
    investmentConstants.DELETE_DCA_ORDER_REQUEST_START,
    deleteDCAOrderRequestStartAsync
  );
}

export function* investmentSagas() {
  yield all([
    call(fetchActivedFundsStart),
    call(fetchAllFundsStart),
    call(fetchAllFundCodesStart),
    call(fetchHistoriesStart),
    call(fetchDCAsSagaStart),
    call(fetchOrdersSagaStart),
    call(fetchPortfoliosStart),
    call(fetchDividendsStart),
    call(fetchNavPortfoliosStart),
    call(fetchPreviousReturnByAccountStart),
    call(fetchHistoryGraphByAccountStart),
    call(fetchPreviousReturnGraphByAccountStart),
    call(fetchProfitByAccountStart),
    call(fetchMonthlyReturnByAccountStart),
    call(fetchMaxDrawdownByAccountStart),
    call(fetchDrawdownByAccountStart),
    call(setDefaultPortStatStart),
    call(fetchVolatilityByAccountStart),
    call(fetchLotsStart),
    call(fetchNavsLotsStart),
    call(fetchBooksStart),
    call(deleteOrderRequestStart),
    call(deleteDCAOrderRequestStart),
  ]);
}
